import Vue from "vue";

import { emitToastr } from "@/lib/Utils";
import Api from "@/lib/Api";
import { io } from "socket.io-client";

import { format, parseISO } from "date-fns";

const { customAlphabet } = require('nanoid');
const nanoid = customAlphabet('1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ', 28);

const audio = new Audio('/notifications/1.mp3');

Vue.prototype.$toast = emitToastr;
Vue.prototype.$api = Api;
Vue.prototype.$io = io;

Object.defineProperty(Vue.prototype, '$isDark', {
    get() {
        return this.$vuetify?.theme?.dark || false;
    }
});

Vue.prototype.$whatsapp_template_categories = [
    { name: 'Marketing', id: 'MARKETING' },
    { name: 'Utilidade', id: 'UTILITY' },
    { name: 'Autenticação', id: 'AUTHENTICATION' }
];

Vue.prototype.$whatsapp_template_statuses = [
    { name: 'Aprovado', id: 'APPROVED', tip: 'Você já pode usar esse template' },
    { name: 'Pendente', id: 'PENDING', tip: 'O template está sendo analisado pela Meta, por favor, aguarde.' },
    { name: 'Rejeitado', id: 'REJECTED', tip: 'O template foi rejeitado pela Meta. Revise seu conteúdo e categoria.' }
];

Vue.prototype.$saveImage = (media_url) => {
    const link = document.createElement('a');
    link.href = media_url;
    link.download = 'imagem.jpg';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

Vue.prototype.$playNotificationSound = () => {
    try {
        audio.play();
    }
    catch (err) {
        return;
    }
}

Vue.prototype.$newID = (type = '') => {
    try {
        return `${nanoid()}${type}`;
    }
    catch (err) {
        return "";
    }
}

Vue.prototype.$notify = (title, body) => {
    if (!("Notification" in window)) {
        return;
    } else if (Notification.permission === "granted") {
        new Notification(title, { body, icon: "favicon.ico", silent: true });
    } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(function (permission) {
            if (permission === "granted") {
                new Notification(title, { body, icon: "favicon.ico", silent: true });
            }
        });
    }
};




Vue.prototype.$date = {
    defaultFormat(value) {
        return format(new Date(value), "dd/MM/yyyy HH:mm");
    },
    format(value, pattern) {
        const isoDate = parseISO(value)

        return format(isoDate, pattern);
    },
    smallFormat(value) {
        if (!value) return;
        if (format(new Date(), "dd/MM/yyyy") == format(new Date(value), "dd/MM/yyyy")) {
            return format(new Date(value), "HH:mm");
        }
        else {
            return format(new Date(value), "dd/MM/yyyy HH:mm");
        }
    },
    calcContextWindow(date) {
        const data = new Date(date);
        const diff = data - new Date();

        if (diff <= 0) return false;

        const horas = Math.floor(diff / (1000 * 60 * 60));
        const minutos = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        return { hours: horas, minutes: minutos, text: `${horas}h ${minutos}min` }
    }
}


Vue.prototype.$utils = {
    pickFile(options) {
        return new Promise((resolve) => {
            const input = document.createElement('input');

            input.type = 'file';
            input.accept = options.accept || '*/*';

            input.onchange = (e) => {
                const file = e.target.files[0];

                resolve(file);
            }

            input.click();
        })
    },
    copy(payload) {
        return JSON.parse(JSON.stringify(payload));
    },

    formatPhone(phone_string) {
        if (!phone_string) return "";
        phone_string = phone_string.replace(/\D/g, '');

        // Divide o número em partes: DDI (55), DDD, e o restante do telefone
        const ddi = phone_string.slice(0, 2); // "55"
        const ddd = phone_string.slice(2, 4); // Exemplo: "11"
        const telefone = phone_string.slice(4);

        // Formata o telefone com base no número de dígitos
        const telefoneFormatado = telefone.length === 9
            ? `${telefone.slice(0, 5)}-${telefone.slice(5)}` // 9 dígitos (ex: 12345-6789)
            : `${telefone.slice(0, 4)}-${telefone.slice(4)}`; // 8 dígitos (ex: 1234-5678)

        return `+${ddi} (${ddd}) ${telefoneFormatado}`;
    },

    formatNumber(num, type = '') {
        if (!num) return '0';
        if (num >= 1_000_000) {
            return `${type} ${(Math.round(num / 100000) / 10)} M`;
        } else if (num >= 1000) {
            return `${type} ${(Math.round(num / 100) / 10)} k`;
        } else {
            return `${type} ${Math.round(num * 10) / 10}`;
        }
    },

    renderBoldText(text = "") {
        return text.replace(/\*(.*?)\*/g, '<b>$1</b>');
    },
    validateOutput(data, originalValue = '', output = undefined) {
        const outputs = data.getOutputs?.() || data.outputs;

        return function (value) {
            if (value?.length > output?.maxLength || value?.length > data?.maxLength) {
                return 'Limite de caracteres atingidos';
            }

            if (typeof value === 'string') {
                const exists = Object.keys(outputs).some(key => key.toLowerCase() === value.toLowerCase() && key.toLowerCase() !== originalValue.toLowerCase());
                if (exists) return 'Já existe uma opção com esse título';
            }

            if (data.type === "randomizer") {
                const number = Number(value);
                if (isNaN(number) || number < 1 || number > 100) {
                    return 'Digite um número entre 1 e 100';
                }
                return true;
            }

            if (data.type === "quick-reply") {
                if (Object.keys(outputs).length > 3 && !output) {
                    return 'Só é possivel adicionar 3 opções nesse componente';
                }
                return true
            }

            return true;
        }
    }
}

Vue.prototype.$rules = {
    required() {
        return (value) => !!value || 'Campo obrigatório';
    }
}

Vue.prototype.$renderChatbotText = (string, object) => string.replaceAll(/\{([^}]+)\}/gi, (_, a) => {
    return a.split(/\.|\[|\]/).filter(p => p !== '').reduce((obj, prop) => {
        return obj ? obj[prop] : "Não tenho essa informação no momento";
    }, object);
});

Vue.prototype.$ratingColor = (rating) => {
    switch (rating) {
        case 'GREEN': return 'green'
        case 'YELLOW': return 'yellow darken-2'
        case 'RED': return 'red'
        default: return 'grey'
    }
}

Vue.prototype.$changelog = [
    {
        "version": "5.0",
        "date": "28/10/2026",
        "changes": [
            "Sugestão de resposta com IA na tela de conversas",
            "Teste de chatbots de IA e fluxos direto pelo painel, sem precisar enviar mensagens pelo WhatsApp",
            "Assistente guiado para conectar números pela API Oficial e pela Coexistência",
            "Novo modelo de IA mais avançado para novos chatbots, resumos de conversas e follow-ups (GPT-6 Luna)",
            "Indicador de \"digitando...\" nas respostas do chatbot de IA pela API Oficial",
            "Shift+Enter agora quebra a linha na posição do cursor ao digitar mensagens",
            "Ajustes visuais nos cards de oportunidades do Kanban",
            "Melhorias gerais e correções de bugs"
        ]
    },
    {
        "version": "4.9",
        "date": "17/09/2026",
        "changes": [
            "Tags de bloqueio em campanhas agora também para audiências importadas (contatos com a tag não recebem a campanha, mesmo que a tag seja adicionada após o agendamento)",
            "Gestão de tags em massa nas conversas em andamento",
            "Transferência de departamento em massa nas conversas em andamento",
            "Opção de trocar o departamento da conversa sem transferir para atendimento humano no fluxo",
            "Envio de templates com variáveis, imagens e vídeos direto na tela de conversas",
            "Suporte a vídeos e documentos no cabeçalho de templates das campanhas pela API Oficial",
            "Motivos de perda personalizados no Kanban",
            "Filtros de chip e data de finalização na tela de conversas finalizadas",
            "Clique nos cards em tempo real do Dashboard para abrir as conversas filtradas",
            "Pesquisa na lista de webhooks",
            "Melhorias gerais e correções de bugs"
        ]
    },
    {
        "version": "4.8",
        "date": "10/07/2026",
        "changes": [
            "Agora é possivel adicionar legendas nas imagens e vídeos enviados pelo fluxo",
            "Bloco de condicional de chip no fluxo (permite que o fluxo siga caminhos diferentes dependendo do chip da conversa atual)",
            "Renderização de variáveis em menus no fluxo (exemplo: {nome:first} ou {global:CNPJ})",
            "Oportunidades ganhas e perdidas no Kanban",
            "Métricas de oportunidades no Dashboard (Taxa de conversão, Receita por funil e Motivos de perda)",
            "Possibilidade de configurar os dias da semana que os follow-ups automáticos serão executados",
            "Melhorias gerais e correções de bugs"
        ]
    },
    {
        "version": "4.7",
        "date": "15/05/2026",
        "changes": [
            "Melhorias visuais no construtor de fluxos",
            "Aviso de alterações não salvas no construtor de fluxos",
            "Função para duplicar blocos no constutor de fluxos, com control + c / control + v",
            "Variáveis globais para usar no construtor de fluxos, exemplo: {global:CNPJ}",
            "Melhorias no bloco de Script JS, permitindo a alteração de variáveis do contato e globais.",
            "Melhorias gerais e correções de bugs"
        ]
    },
    {
        "version": "4.6",
        "date": "02/04/2026",
        "changes": [
            "Coexistência da API Oficial da Meta",
            "Fluxos inteligentes na IA (permite que a IA acione fluxos automaticamente durante a conversa)",
            "Melhorias gerais e correções de bugs"
        ]
    },
    {
        "version": "4.5",
        "date": "18/02/2026",
        "changes": [
            "Controle de acesso dos usuários aos funis",
            "Filtro de data em conversas em andamento",
            "Filtro de data no kanban",
            "Ações de inatividade",
            "Agendamento de mensagens na API Oficial",
            "Envio de variáveis nos templates via API",
            "Resposta de uma mensagem específica",
            "Melhorias gerais e correções de bugs"
        ]
    },
    {
        "version": "4.4",
        "date": "15/12/2025",
        "changes": [
            "Modo escuro",
            "Oportunidades no fluxo",
            "Correções de bugs e melhorias"
        ]
    },
    {
        "version": "4.3",
        "date": "20/11/2025",
        "changes": [
            "Kanban implementado. Gerencie suas oportunidades de modo fácil e rápido!",
            "Correções e melhorias na conexão direta do Whatsapp"
        ]
    },
    {
        "version": "4.2",
        "date": "21/09/2025",
        "changes": [
            "Novo componente de horário de atendimento no fluxo",
            "Novo componente de distribuição igualitária de atendimento entre atendentes no fluxo",
            "Melhorias gerais e correções de bugs"
        ]
    },
    {
        "version": "4.1",
        "date": "21/08/2025",
        "changes": [
            "API Oficial disponível na plataforma (agora somos Tech Providers da Meta)!",
            "Filtro de data de criação na página de contatos",
            "Possibilidade de exportar contatos com filtros",
            "Melhorias e correções de bugs"
        ]
    },
    {
        "version": "4.0",
        "date": "25/07/2025",
        "changes": [
            "Follow-ups automáticos agora podem ser configurados separadamente por chips",
            "Melhorias e correções de bugs"
        ]
    },
    {
        "version": "3.9",
        "date": "15/07/2025",
        "changes": [
            "Webhooks nativos na plataforma"
        ]
    },
    {
        "version": "3.8",
        "date": "23/06/2025",
        "changes": [
            "Gestão de permissões mais customizável",
            "Importação e exportação de fluxos",
            "Edição de outputs no fluxo",
            "Edição de variáveis nos contatos",
            "Melhorias e correções gerais"
        ]
    },
    {
        "version": "3.7",
        "date": "01/05/2025",
        "changes": [
            "Possibilidade de enviar mensagens com assinatura do atendente (Atendimento --> ícone de configuração --> Ativar assinatura)",
            "Fluxo com novos componentes e melhorias: condicional por existência de tag, testes no componente de requisição, possibilidade de enviar somente o primeiro nome do contato no chat com {nome:first}",
            "Envie imagens no chat através do atalho CTRL + V",
            "Transferências (departamento, atendimento humano e reabertura) agora jogam a conversa para topo da lista de conversas em andamento",
            "Correções de bugs e melhoria de performance geral"
        ]
    },
    {
        "version": "3.6",
        "date": "24/04/2025",
        "changes": [
            "Correção de bug no gatilho de fluxos",
            "Melhoria de performance na tela de atendimento",
            "Possibilidade de mudar nome do contato na tela de atendimento"
        ]
    },
    {
        "version": "3.5",
        "date": "06/03/2025",
        "changes": [
            "Menu de botões (lista) no fluxo (funcionalidade experimental - em homologação)",
            "Possibilidade de desativar gatilhos de fluxo em determinados chips (ver opções do gatilho)",
            "Correção de bug no cadastro de campanha de fluxo"
        ]
    },
    {
        "version": "3.4",
        "date": "22/02/2025",
        "changes": [
            "Sistema de follow-ups automáticos (nova área no menu lateral)",
            "Mensagens de localização agora são reconhecidas pelo chat"
        ]
    },
    {
        "version": "3.3",
        "date": "17/02/2025",
        "changes": [
            "Adicionadas mensagens de sistema na conversa - transferências, inícios e finalizações manuais de conversas serão registrados apenas no sistema (o contato não verá as mensagens)."
        ]
    },
    {
        "version": "3.2",
        "date": "14/02/2025",
        "changes": [
            "Possibilidade de duplicar campanhas.",
            "Possibilidade de enviar campanhas por tags, mas também excluindo contatos que tenham alguma tag específica.",
            "Correções nos filtros da área de atendimento."
        ]
    },
    {
        "version": "3.1",
        "date": "31/01/2025",
        "changes": [
            "Correções e ajustes visuais.",
            "Sistema de validação dos contatos na importação via planilha."
        ]
    },
    {
        "version": "3.0",
        "date": "19/01/2025",
        "changes": [
            "Novo design.",
            "Opção para ligar ou desligar notificações sonoras.",
            "Restrição de acessos: agora é possível restringir acessos de gerentes no 'dashboard', 'contatos' e 'equipe' e atendentes em 'contatos'.",
            "Apenas proprietários de contas podem finalizar conversas em massa.",
            "Melhorias no sistema de espera de respostas da IA."
        ]
    },
    {
        "version": "2.8",
        "date": "14/12/2024",
        "changes": [
            "Assistente de inteligência artificial para resumir conversas.",
            "Assistente de inteligência artificial para criar follow-ups personalizados.",
            "Atendentes não poderão mais exportar lista de contatos. Somente gerentes e proprietários terão permissão para essa operação."
        ]
    },
    {
        "version": "2.7",
        "date": "12/12/2024",
        "changes": [
            "Gatilhos de fluxos a partir de palavras-chave.",
            "Mehorias de performance."
        ]
    },
    {
        "version": "2.6",
        "date": "07/12/2024",
        "changes": [
            "Novo bloco (componente) de finalizar atendimento no fluxo.",
            "Ao criar uma tag, um departamento ou um chatbot na plataforma, os dados são automaticamente atualizados no fluxo, sem necessidade de atualizar a tela.",
            "Todos os chatbots de IA foram instruídos a não responder com texto formatado com markdown (Exemplo: **Item1** ou [LINK] (https://meusite.com) ).",
            "Proteções para evitar que departamentos ou fluxos ligados a canais sejam apagados.",
            "Contextos de chatbots de IA agora estão limitados a 25 mil caracteres para melhorar a assertividade do chatbot e evitar confusões e lentidão nas respostas.",
            "Melhorias no desempenho do sistema de envios de mensagens e listagem de conversas.",
            "Possibilidade de iniciar uma conversa em um departamento específico.",
            "Assistente de criação de chatbots de IA com modelos pré configurados.",
            "Correções de bugs e melhorias gerais no sistema."
        ]
    },
    {
        "version": "2.5",
        "date": "26/11/2024",
        "changes": [
            "Melhoria de desempenho na página de atendimentos (chat).",
            "Correções de bugs menores."
        ]
    },
    {
        "version": "2.4",
        "date": "22/11/2024",
        "changes": [
            "Importação de contatos e suas propriedades.",
            "Novas conversas iniciadas por nome do contato, ao invés de somente o telefone.",
            "Tratamento e avisos de erros nos envios de mensagem.",
            "Correção do bug de gravação de áudio na biblioteca.",
            "Visualização do estado de conexão dos chips no menu lateral."
        ]
    },
    {
        "version": "2.3",
        "date": "10/10/2024",
        "changes": [
            "Novo sistema de conexão, garantindo mais estabilidade aos chips conectados.",
            "Migração para servidores com maior capacidade.",
            "Possibilidade de renomear canais / chips.",
            "Correções e melhorias gerais."
        ]
    },
    {
        "version": "2.2",
        "date": "08/08/2024",
        "changes": [
            "Fluxo: componente temporizador de envio (atraso programado no envio das mensagens).",
            "Fluxo: componente randomizador (distribuição randômica)"
        ]
    },
    {
        "version": "2.1",
        "date": "30/08/2024",
        "changes": [
            "Gestão de conversas que estão aguardando resposta. Dashboard aprimorado.",
            "Botão de duplicar fluxo.",
            "Assinaturas atrasadas não terão seus canais desconectados automaticamente. Apenas as canceladas.",
            "Correção do bug na criação de atendente com departamentos selecionados.",
            "Correção do bug que não atualizava em tempo real algumas novas conversas que deveriam chegar na página de conversas em andamento.",
            "Correção do bug que não exibia documentos PDF com legenda.",
            "Melhorias na estabilidade da conexão com Whatsapp."
        ]
    },
    {
        "version": "2.0",
        "date": "24/08/2024",
        "changes": [
            "API agora pode disparar fluxos, criando a possibilidade de implementações de integrações complexas.",
            "Campanha e agendamento de fluxo agora removem o status de atendimento humano.",
            "Todos os áudios enviados via fluxo serão considerados como gravados na hora.",
            "Correções de bugs e melhorias de desempenho."
        ]
    },
    {
        "version": "1.9",
        "date": "20/08/2024",
        "changes": [
            "Agora chatbots de IA saberão data e hora atuais.",
            "Correção da foto de perfil dos contatos.",
            "Correção do bug de filtros nas conversas em andamento.",
            "Melhoria no sistema de reconexão do Whatsapp."
        ]
    },
    {
        "version": "1.8",
        "date": "13/08/2024",
        "changes": [
            "Acompanhamento de campanhas em andamento em tempo real: quando a campanha está enviando mensagens, um novo botão \"Acompanhar\" fica disponível, mostrando as principais informações dos envios.",
            "Possibilidade de cancelar campanhas em andamento.",
            "Campanhas e envios agendados de TEXTO (não fluxo) são enviados normalmente, porém agora NÃO criam atendimentos/conversas automaticamente, até que o contato responda a mensagem. Ao responder, a conversa será criada de acordo com o primeiro atendimento cadastrado no canal: chatbot de IA, chatbot de fluxo ou atendimento humano."
        ]
    },
    {
        "version": "1.7",
        "date": "11/08/2024",
        "changes": [
            "Área de dados do contato com tags, variáveis e anotações: Na área de contatos ou nas conversas em andamento, acesse uma conversa e clique no nome do contato ou no menu e acesse \"Dados do contato\".",
            "Correções diversas nas campanhas e no fluxo.",
            "Melhoria no desempenho dos chatbots de IA."
        ]
    },
    {
        "version": "1.6",
        "date": "31/07/2024",
        "changes": [
            "Construtor de fluxos.",
            "Possibilidade de ter chatbots de IA enviando para fluxos e fluxos enviando para IA.",
            "Campanhas podem disparar fluxos.",
            "Agendamentos individuais podem disparar fluxos.",
            "Novos tutoriais na área \"Como usar a plataforma\".",
            "Conversas por chatbot agora finalizam automaticamente após 48 horas de inatividade (antes eram 30 minutos).",
            "Possibilidade de encerrar atendimentos de chatbot sem precisar transferir para humano antes."
        ]
    },
    {
        "version": "1.5",
        "date": "03/07/2024",
        "changes": [
            "Emojis no campo de mensagem (atendimento humano).",
            "Possibilidade de exportar contatos.",
            "Som de notificação ao receber nova mensagem (tela conversas em andamento).",
            "Chatbot não responde mais \"por cima\" do atendimento humano.",
            "Melhorias no agendamento de mensagem individual.",
            "Melhorias gerais de UX."
        ]
    },
    {
        "version": "1.4",
        "date": "23/06/2024",
        "changes": [
            "API de envio de mensagens via sistemas externos.",
            "Paginação nas conversas em andamento.",
            "Correções de bugs menores."
        ]
    },
    {
        "version": "1.3",
        "date": "16/06/2024",
        "changes": [
            "Sistema de tagueamento automático por palavras-chave (para usar, edite suas tags).",
            "Possibilidade de transferência para humano quando o chatbot receber imagens ou documentos (nas configurações do chatbot).",
            "Correção do bug nos filtros de tag da tela de conversas finalizadas.",
            "Agora o chat mostra quando uma mensagem do usuário é uma resposta a outra mensagem, trazendo o conteúdo original.",
            "Melhorias de desempenho."
        ]
    },
    {
        "version": "1.2",
        "date": "06/06/2024",
        "changes": [
            "Nome do autor da mensagem (atendente) exibido na plataforma (não é exibido para o contato).",
            "Atalho para gravação de áudio na conversa.",
            "Possibilidade de envio de midia sem salvar na biblioteca.",
            "Melhoria no layout da biblioteca de midia.",
            "Possibilidade de conectar canais diretamente com o atendimento humano."
        ]
    },
    {
        "version": "1.1",
        "date": "31/05/2024",
        "changes": [
            "Dashboard com filtro por canal / número conectado.",
            "Sistema de atraso no envio de mensagens por chatbot: Evita que seu chatbot responda imediatamente a uma pergunta. Pode ser configurado na área \"Chatbots inteligentes\", editando seu chatbot. Seção \"ajustes gerais\", opção \"Atraso na resposta\".",
            "Comportamento humano: agora o chatbot aguarda 2 segundos entre visualizar a mensagem e começar a digitar. Também digita por 5 segundos antes de enviar a resposta."
        ]
    }
]